import {useState} from 'react';
import {useSelector} from 'react-redux';

import {ThemeProvider} from '@mui/material';

import {BrowserRouter, Route, Switch} from "react-router-dom";
// import { HomePage } from "../../pages/home/HomePage.jsx";
import {DocFr} from "../../pages/doc-fr/DocFr.jsx";
import {DocRz} from "../../pages/doc-rz/DocRz.jsx";
import Dashboard from "../../pages/Dashboard"

import Panel from '../../UIComponents/Panel/index.js'
import Map from '../MapLayout/index.js'
import ResizebleDrawer from '../../UIComponents/ResizebleDrawer';
import {BlockLeftMain} from '../main/BlockLeftMain';
import DirectoryList from '../DirectoryList';
import DocumentList from '../DocumentList';
import GeozoneDravingPalette from '../GeozoneDravingPalette';
import CheckBoxController from '../CheckBoxController';


import './App.css';
import theme from './theme';
import XlsxSaver from '../XlsxSaver/XlsxSaver.js';
import Reports from '../../pages/Reports/Reports.jsx';
import LoginDialog from '../../pages/LoginDialog';

import mapStateToProps from './mapStateToProps.js';
import Directory from '../../pages/Directory';
import Footer from "../../UIComponents/Footer";
import DocumentShedule from '../../pages/DocumentShedule';
import DocumentSheduleOperation from '../../pages/DocumentSheduleOperation';
import WorkOrder from '../../pages/WorkOrder';
import WorkOrderOperation from '../../pages/WorkOrderOperation';

// const App = () => null
function App() {

  const [loginShow, setLoginShow] = useState(false)

  const {
    isLoggedIn,
    user,
  } = useSelector(mapStateToProps);

  return (
    <ThemeProvider theme={theme}>
      {isLoggedIn ? (
        <BrowserRouter>
          <Panel />
          <Footer />
          <Switch>
            <Route path="/" exact >
              <Map />
            </Route>
            <Route path="/geozone/:zoneId?" exact >
              <Map geoedit={true}/>
            </Route>
            <Route path="/doc" exact >
              {/* это по кучке */}
              <DocFr />
            </Route>
            <Route path="/doc2" exact >
              {/* это по одинокому трекеру */}
              <>
                <CheckBoxController />
                <DocRz />
              </>
            </Route>
            <Route path="/dashboard" exact >
              {/* дашборды тоже по одинокому трекеру */}
              <>
                <CheckBoxController />
                <Dashboard />
              </>
            </Route>
            <Route path="/reports" exact >
              {/* Отчеты */}
              <Reports />
            </Route>
            <Route path="/directory/:dirname?" exact >
              {/* Справочники */}
              <Directory />
            </Route>

            <Route path="/document/schedule" exact >
              {/* Документы - план-графики список*/}
              <DocumentShedule />
            </Route>
            <Route path="/document/schedule/add" exact >
              {/* Документы - план-графики добавление*/}
              <DocumentSheduleOperation variant="add"/>
            </Route>
            <Route path="/document/schedule/edit/:docId" exact >
              {/* Документы - план-графики редактирование*/}
              <DocumentSheduleOperation variant="edit"/>
            </Route>
            <Route path="/document/schedule/view/:docId" exact >
              {/* Документы - план-графики просмотр (и создание на основе них заказ-наряда)*/}
              <DocumentSheduleOperation variant="view"/>
            </Route>
            <Route path="/document/work-order" exact >
              {/* Документы - заказ-няряд список*/}
              <WorkOrder />
            </Route>
            <Route path="/document/work-order/add/:sheduleId/:workId" exact >
              {/* Документы - заказ-няряд добавление*/}
              <WorkOrderOperation variant="add"/>
            </Route>
            <Route path="/document/work-order/edit/:docId" exact >
              {/* Документы - заказ-няряд редактирование*/}
              <WorkOrderOperation variant="edit"/>
            </Route>
            <Route path="/document/work-order/view/:docId" exact >
              {/* Документы - заказ-няряд просмотр*/}
              <WorkOrderOperation variant="view"/>
            </Route>
          </Switch>
          <XlsxSaver />
          <Switch>
            <Route path={["/", "/doc", "/doc2", "/dashboard", "/reports"]} exact>
              <ResizebleDrawer content={<BlockLeftMain />} />
            </Route>
            <Route path="/directory/:dirname?" >
              <ResizebleDrawer content={<DirectoryList />} />
            </Route>
            <Route path="/document/:docname?" >
              <ResizebleDrawer content={<DocumentList />} />
            </Route>
            <Route path="/geozone/:zoneId?" exact>
              <ResizebleDrawer content={<GeozoneDravingPalette />} />
            </Route>
          </Switch>
          {/* <DataPalete /> */}
        </BrowserRouter>
      ) : (
        <LoginDialog />
      )}
    </ThemeProvider>
  );
  // return (
  //     <BrowserRouter>
  //         <Switch>
  //             <Route path="/" exact >
  //                 <HomePage />
  //             </Route>
  // <Route path="/doc" exact >
  //     <DocFr />
  // </Route>
  // <Route path="/doc2" exact >
  //     <DocRz />
  // </Route>

  //             {/*<Route path="/management/:subpage?/*" element={<Management />} />*/}
  //             {/*<Route path="/management/doc" element={<DocsMain />} />*/}
  //             {/*<Route path="/management/doc2" element={<DocsSecond />} />*/}
  //             {/*<Route path="/management/doc3" element={<Body />} />*/}
  //         </Switch>
  //     </BrowserRouter>
  // )
}

export default App
